import script from "./EnvironmentIndicator.vue?vue&type=script&setup=true&lang=js"
export * from "./EnvironmentIndicator.vue?vue&type=script&setup=true&lang=js"

import "./EnvironmentIndicator.vue?vue&type=style&index=0&id=74abb7f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-74abb7f0"]])

export default __exports__